function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add('user-is-tabbing');
    window.removeEventListener('keydown', handleFirstTab);
  }
}

function init() {
  window.addEventListener('keydown', handleFirstTab);
}

export default init;



// WEBPACK FOOTER //
// ./src/scripts/mando-lib.kb-user.js